import "@fontsource-variable/bricolage-grotesque"
import "@fontsource/ibm-plex-sans-arabic/400.css"
import "@fontsource/ibm-plex-sans-arabic/600.css"
import "@fontsource/ibm-plex-sans-arabic/700.css"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

import App from "@/App"
import { PreferencesProvider } from "@/preferences"
import "@/styles.css"

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <PreferencesProvider>
      <App />
    </PreferencesProvider>
  </StrictMode>,
)
